import { combineReducers, createFeature } from '@ngrx/store';

import { childSurveysReducer } from './survey-list/reducers/child-surveys.reducer';
import { surveyQueryReducer } from './survey-list/reducers/survey-query.reducer';
import { bulkOpeartionReducer } from './bulk-edit/reducers/bulk-operation.reducer';
import { surveyReferenceReducer } from './reference/survey-reference.reducer';
import { manageSurveyReducer } from './manage-survey/manage-survey.reducer';
import { SurveyState } from './survey-state.model';

export const surveyFeatureKey = 'survey';

const surveyReducer = combineReducers<SurveyState>({
  query: surveyQueryReducer,
  children: childSurveysReducer,
  bulkOperation: bulkOpeartionReducer,
  reference: surveyReferenceReducer,
  manageSurvey: manageSurveyReducer,
});

export const surveyFeature = createFeature({
  name: surveyFeatureKey,
  reducer: surveyReducer,
});
